"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, Vue, Ref, PropSync } from "vue-property-decorator";
import MarkdownItVue from "markdown-it-vue";
import "markdown-it-vue/dist/markdown-it-vue.css";
import markdownItCodeCopy from "markdown-it-code-copy";
let Mked = class extends Vue {
  constructor() {
    super(...arguments);
    this.options = {
      markdownIt: {
        copy: true,
        plugins: [markdownItCodeCopy]
      }
    };
  }
  mounted() {
    this._myMarkdownItVue.use(markdownItCodeCopy, {
      buttonClass: "mdcopy",
      iconStyle: "font-size: 11px; opacity: 0.7;",
      buttonStyle: "position: absolute; top: 2px; right: 1px; cursor: pointer; outline: none;"
    });
  }
};
__decorateClass([
  PropSync("content", {
    type: String,
    default: () => {
      return "";
    }
  })
], Mked.prototype, "contentData", 2);
__decorateClass([
  Ref("myMarkdownItVue")
], Mked.prototype, "_myMarkdownItVue", 2);
Mked = __decorateClass([
  Component({
    components: {
      MarkdownItVue,
      markdownItCodeCopy
    }
  })
], Mked);
export {
  Mked as default
};
